import * as actionTypes from '../actionTypes';
import { ManualAssistantQueryRequest } from 'api/manualAssistant';
import {
    ManualAssistantQueryFailureAction,
    ManualAssistantQueryFailurePayload,
    ManualAssistantQueryRequestAction,
    ManualAssistantQueryResult,
    ManualAssistantQuerySuccessAction,
} from 'redux/types/manualAssistantActionModel';

export const queryManualAssistantRequest = (
    payload: ManualAssistantQueryRequest,
): ManualAssistantQueryRequestAction => ({
    type: actionTypes.MANUAL_ASSISTANT_QUERY_REQUEST,
    payload,
});

export const queryManualAssistantSuccess = (
    payload: ManualAssistantQueryResult,
): ManualAssistantQuerySuccessAction => ({
    type: actionTypes.MANUAL_ASSISTANT_QUERY_SUCCESS,
    payload,
});

export const queryManualAssistantFailure = (
    payload: ManualAssistantQueryFailurePayload,
): ManualAssistantQueryFailureAction => ({
    type: actionTypes.MANUAL_ASSISTANT_QUERY_FAILURE,
    payload,
});
